import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import pdfMake from 'pdfmake/build/pdfmake';
import { Subscription, finalize } from 'rxjs';
import { AnalyticsService } from '../../@core/utils';
import { Classroom } from '../../interface/calendar';
import { OpenAiAssistantService } from '../../services/open-ai-assistant.service';
import { StorageService } from '../../services/storage.service';

@Component({
  selector: 'ngx-view-recommendation-template',
  templateUrl: './view-recommendation-template.component.html',
  styleUrls: ['./view-recommendation-template.component.scss'],
})
export class ViewRecommendationTemplateComponent implements OnInit, OnDestroy {
  @ViewChild('viewRecommendationTemplate')
  viewRecommendationTemplate: TemplateRef<any>;
  @ViewChild('recommendationContent') recommendationContent: ElementRef;
  recommendationValues = {
    section_id: '',
    recommendationStr: '',
  };
  @Input() isGenerate: boolean;
  @Input() recommendations: any;
  @Input() classroom: Classroom;
  @Output() resetSubmitArea = new EventEmitter<boolean>();
  data: any;
  imageData: string;
  public loading = true;
  standardForRecommendation = '';
  subjectId: number;
  gradeId: number;
  recommendation_section: any;
  responseStreamSubscription: Subscription;

  constructor(
    public analyticsService?: AnalyticsService,
    public storageService?: StorageService,
    public dialog?: MatDialog,
    public router?: Router,
    private openAIAssistantService?: OpenAiAssistantService,
    private spinner?: NgxSpinnerService,
  ) {
    this.responseStreamSubscription = this.openAIAssistantService.recommendation.subscribe((res) => {
      if (res) {
        this.recommendationValues = res;
        this.recommendations['recommendation'] = res.recommendationStr
          .replace(/(^|[^$])#+/g, '$1')
          .replace(/(^|[^$])\*\*/g, '$1');
      }
    });

    // this.responseStreamSubscription = this.openAIAssistantService.recommendation
    //   .pipe(finalize(() => this.spinner.hide()))
    //   .subscribe((res) => {
    //     if (res) {
    //       this.spinner.show();
    //       this.recommendationValues = res;
    //       this.recommendations['recommendation'] = res.recommendationStr;
    //     }
    //   });
  }

  async ngOnInit() {
    this.loading = true;
    try {
      if (Array.isArray(this.recommendations.section_id)) {
        const joinedSection = this.recommendations.section_id.join(' \n ');
        this.recommendation_section = joinedSection.split('\n ');
      } else {
        this.recommendation_section = this.recommendations.section_id
          ? this.recommendations.section_id.split('. and ')
          : [];
      }
    } catch (error) {
      // console.log(error);
    }
  }

  async makePdf() {
    try {
      this.analyticsService?.trackEvent('Generate Pdf', 'Calender');
      this.loading = true;

      if (Array.isArray(this.recommendations.section_id)) {
        const joinedSection = this.recommendations.section_id.join(' \n ');
        this.recommendation_section = joinedSection.split('\n ');
      } else {
        this.recommendation_section = this.recommendations.section_id
          ? this.recommendations.section_id.split('. and ')
          : [];
      }

      const pdfData = await this.generateDataForPDF(this.recommendations);
      const docDefinition: any = {
        info: {
          title: `Respond-Edu-Recommendation`,
        },
        content: [
          {
            image: this.imageData,
            width: 100,
            alignment: 'left',
            style: 'heading',
            margin: [-20, 0, 0, 5],
          },
          { text: 'Recommendation of the day\n', style: 'heading' },
          { text: new Date().toDateString(), style: 'heading' },
          {
            text: [
              { text: '\nSection ID- ', style: 'heading' },
              {
                text: `${this.recommendation_section.join('\n\n')}\n\n`,

                style: 'information',
              },
            ],
          },
          pdfData,
        ],
        styles: {
          table: {
            margin: [0, 0, 0, 7],
          },
          assignmentType: {
            color: 'purple',
            border: false,
          },
          heading: {
            bold: true,
            fontSize: 14,
            margin: [0, 0, 0, 5],
          },
          answer: {
            fontSize: 10,
            margin: [0, 15, 0, 15],
          },
          information: {
            fontSize: 13,
          },
        },
      };
      pdfMake.createPdf(docDefinition).download('Respond-Edu-Recommendation');
    } catch (error) {
      console.log(error);
      this.loading = false;
    }
  }

  async generateDataForPDF(data: any) {
    this.imageData = await this.getImageDataUrl('/assets/images/Logo.png');

    const questionTable = {
      style: 'table',
      table: {
        dontBreakRows: false,
        body: [
          [
            {
              text: [
                {
                  text: `${data.recommendation}\n\n`,
                  fontSize: 13,
                },
              ],
              alignment: 'left',
              margin: [5, 10, 0, 0],
              border: [true, true, true, true],
            },
          ],
        ],
      },
    };
    return questionTable;
  }

  async getImageDataUrl(imageUrl: string): Promise<string> {
    return fetch(imageUrl)
      .then((response) => response.blob())
      .then((blob) => {
        return new Promise<string>((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result as string);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      });
  }
  ngOnDestroy(): void {
    this.responseStreamSubscription?.unsubscribe();
  }
}
